import classNames from "@calcom/lib/classNames";
import { useLocale } from "@calcom/lib/hooks/useLocale";

interface ISteps {
  maxSteps: number;
  currentStep: number;
  navigateToStep: (step: number) => void;
  stepLabel?: (currentStep: number, maxSteps: number) => string;
  unclickableIndices?: number[];
}

const Steps = (props: ISteps) => {
  const { maxSteps, currentStep, navigateToStep, stepLabel, unclickableIndices } = props;
  const { t } = useLocale();
  return (
    <div className="mb-12 space-y-2">
      <div className="flex w-full space-x-2 rtl:space-x-reverse">
        {new Array(maxSteps).fill(0).map((_s, index) => {
          if (unclickableIndices && unclickableIndices.includes(index)) {
            return index <= currentStep - 1 ? (
              <div
                key={`step-${index}`}
                className={classNames(
                  "bg-brand-500 h-1 w-full rounded dark:bg-white",
                  index < currentStep - 1 ? "cursor-not-allowed" : ""
                )}
              />
            ) : (
              <div key={`step-${index}`} className="bg-brand-500 h-1 w-full rounded-[1px] bg-opacity-25" />
            );
          }

          return index <= currentStep - 1 ? (
            <div
              key={`step-${index}`}
              onClick={() => navigateToStep(index)}
              className={classNames(
                "bg-brand-500 h-1 w-full rounded dark:bg-white",
                index < currentStep - 1 ? "cursor-pointer" : ""
              )}
            />
          ) : (
            <div key={`step-${index}`} className="bg-brand-500 h-1 w-full rounded-[1px] bg-opacity-25" />
          );
        })}
      </div>
      <p className="text-xs font-medium text-gray-500 dark:text-white">
        {stepLabel ? stepLabel(currentStep, maxSteps) : t("current_step_of_total", { currentStep, maxSteps })}
      </p>
    </div>
  );
};
export { Steps };
